import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';
import BoletoV2 from '@/components/templates/BoletoV2';
import Boleto25Banner from '@/components/organisms/Boleto25Banner';
import DenFraudes from '@/components/templates/DenFraudes';
import { BoletoTabs } from '@/data/misc/boleto-tabs';
import React, { useState } from 'react';
import CustomTabs from '../CustomTabs';
import Boleto25Perguntas from '@/components/organisms/Boleto25Perguntas';
import Boleto25Conteudos from '@/components/organisms/Boleto25Conteudos';
import DenunciasFraudes25Banner from '@/components/organisms/DenunciasFraudes25Banner';
import Styles from './TabGroupBoleto.css';

function TabGroupBoleto({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <>
      <Header24 />

      {currentTab === BoletoTabs.boleto.id && <Boleto25Banner />}
      {currentTab === BoletoTabs['denuncias-e-fraudes'].id && <DenunciasFraudes25Banner />}

      <CustomTabs initialTab={tab} tabs={BoletoTabs} onTabChanged={handleTab} />

      {currentTab === BoletoTabs.boleto.id && <BoletoV2 />}
      {currentTab === BoletoTabs['denuncias-e-fraudes'].id && <DenFraudes />}

      <Boleto25Perguntas />
      <Boleto25Conteudos />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupBoleto;
